[0, 1, 2, 3, 4, 5, 6, 12, 24, 48]
